import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { styleVariables } from '@lib/common';
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "count-down-component__Container",
  componentId: "sc-aud4pw-0"
})(["height:160px;background:", ";box-shadow:0px 3px 6px rgba(0,0,0,0.12);padding:24px;border-radius:16px;display:flex;flex-direction:column;margin-top:40px;justify-content:center;overflow:scroll;margin-bottom:16px;::-webkit-scrollbar{width:0;}"], styleVariables.colors.gray1);
var CountDownTitle = styled.span.withConfig({
  displayName: "count-down-component__CountDownTitle",
  componentId: "sc-aud4pw-1"
})(["font-size:16px;font-weight:600;"]);
var CountDownTimeContainer = styled.div.withConfig({
  displayName: "count-down-component__CountDownTimeContainer",
  componentId: "sc-aud4pw-2"
})(["display:flex;justify-content:space-around;padding:16px 0 0 0;"]);
var CountDownTimeColumn = styled.div.withConfig({
  displayName: "count-down-component__CountDownTimeColumn",
  componentId: "sc-aud4pw-3"
})(["display:flex;flex-direction:column;align-items:center;margin:0 8px 0 8px;"]);
var CountDownTimeNumber = styled.div.withConfig({
  displayName: "count-down-component__CountDownTimeNumber",
  componentId: "sc-aud4pw-4"
})(["display:flex;font-size:24px;gap:32px;align-items:center;font-weight:normal;color:", ";"], function (props) {
  return props.isWarning ? styleVariables.colors.red3 : styleVariables.colors.blue3;
});
var CountDownTimeTitle = styled.div.withConfig({
  displayName: "count-down-component__CountDownTimeTitle",
  componentId: "sc-aud4pw-5"
})(["font-size:16px;font-weight:400;color:", ";"], styleVariables.colors.gray10);
export var CountDownComponent = function CountDownComponent(props) {
  var endTime = props.endTime,
      updateSubmissionEndTime = props.updateSubmissionEndTime; // updateSubmissionEndTime

  var _useState = useState({
    countdownDays: '',
    countdownHours: '',
    countdownMinutes: '',
    countdownSeconds: ''
  }),
      countdownTime = _useState[0],
      setCountdownTime = _useState[1];

  var endTimeFormat = moment.unix(parseInt(endTime));
  useEffect(function () {
    var timeInterval = setInterval(function () {
      var countdownDateTime = endTimeFormat.valueOf();
      var currentTime = moment().valueOf();
      var remainingDayTime = countdownDateTime - currentTime;
      var totalDays = Math.floor(remainingDayTime / (1000 * 60 * 60 * 24));
      var totalHours = Math.floor(remainingDayTime % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      var totalMinutes = Math.floor(remainingDayTime % (1000 * 60 * 60) / (1000 * 60));
      var totalSeconds = Math.floor(remainingDayTime % (1000 * 60) / 1000);
      var runningCountdownTime = {
        countdownDays: totalDays.toString(),
        countdownHours: totalHours.toString(),
        countdownMinutes: totalMinutes.toString(),
        countdownSeconds: totalSeconds.toString()
      };
      setCountdownTime(runningCountdownTime);

      if (remainingDayTime < 0) {
        clearInterval(timeInterval);
      }
    }, 1000);
    return function () {
      return clearInterval(timeInterval);
    };
  }, [endTimeFormat]);
  var isWarning = useMemo(function () {
    return parseInt(countdownTime.countdownMinutes) < 6;
  }, [countdownTime.countdownMinutes]);

  var CountDownTime = function CountDownTime() {
    return /*#__PURE__*/_jsxs(CountDownTimeContainer, {
      children: [/*#__PURE__*/_jsxs(CountDownTimeColumn, {
        children: [/*#__PURE__*/_jsx(CountDownTimeNumber, {
          isWarning: isWarning,
          children: parseInt(countdownTime.countdownDays) < 0 ? 0 : parseInt(countdownTime.countdownDays) || 0
        }), /*#__PURE__*/_jsx(CountDownTimeTitle, {
          children: "Ng\xE0y"
        })]
      }), /*#__PURE__*/_jsxs(CountDownTimeColumn, {
        children: [/*#__PURE__*/_jsx(CountDownTimeNumber, {
          isWarning: isWarning,
          children: parseInt(countdownTime.countdownHours) < 0 ? 0 : parseInt(countdownTime.countdownHours) || 0
        }), /*#__PURE__*/_jsx(CountDownTimeTitle, {
          children: "Gi\u1EDD"
        })]
      }), /*#__PURE__*/_jsxs(CountDownTimeColumn, {
        children: [/*#__PURE__*/_jsx(CountDownTimeNumber, {
          isWarning: isWarning,
          children: parseInt(countdownTime.countdownMinutes) < 0 ? 0 : parseInt(countdownTime.countdownMinutes) || 0
        }), /*#__PURE__*/_jsx(CountDownTimeTitle, {
          children: "Ph\xFAt"
        })]
      }), /*#__PURE__*/_jsxs(CountDownTimeColumn, {
        children: [/*#__PURE__*/_jsx(CountDownTimeNumber, {
          isWarning: isWarning,
          children: parseInt(countdownTime.countdownSeconds) < 0 ? 0 : parseInt(countdownTime.countdownSeconds) || 0
        }), /*#__PURE__*/_jsx(CountDownTimeTitle, {
          children: "Gi\xE2y"
        })]
      })]
    });
  };

  var isEndTime = parseInt(countdownTime.countdownDays) < 0 && parseInt(countdownTime.countdownHours) < 0 && parseInt(countdownTime.countdownMinutes) < 0 && parseInt(countdownTime.countdownSeconds) < 0;
  useEffect(function () {
    if (isEndTime) {
      updateSubmissionEndTime();
    }
  }, [isEndTime, updateSubmissionEndTime]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(CountDownTitle, {
      children: "Th\u1EDDi gian"
    }), /*#__PURE__*/_jsx(CountDownTime, {})]
  });
};